import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "Dialogo",
  icon: "💬",
  templates: [
    {
      title: "Modello di Intervista Podcast",
      content: `Scrivi un'intervista in stile podcast tra due parlanti.
- Il parlante 1 è il conduttore: [un giornalista tecnologico curioso ed entusiasta].
- Il parlante 2 è l'ospite: [un rinomato ricercatore di IA che ha appena pubblicato un articolo rivoluzionario].
- L'argomento di discussione è [il futuro della collaborazione umano-IA nei campi creativi].
- Il tono dovrebbe essere [conversazionale, perspicace e occasionalmente umoristico].
- Includi scambi naturali con domande di approfondimento e aneddoti.

Formatta ogni riga come "Speaker 1:" o "Speaker 2:" seguito dal loro dialogo.`,
      mode: 'multi'
    },
    {
      title: "Modello di Dibattito",
      content: `Scrivi un dibattito strutturato tra due parlanti con punti di vista opposti.
- Il parlante 1 argomenta [a favore del lavoro da remoto come standard permanente].
- Il parlante 2 argomenta [che la collaborazione in ufficio è essenziale per l'innovazione].
- Entrambi i parlanti devono presentare [argomentazioni ben ragionate con esempi concreti].
- Il tono dovrebbe essere [rispettoso ma appassionato].
- Ogni parlante deve rispondere direttamente ai punti dell'altro.

Formatta ogni riga come "Speaker 1:" o "Speaker 2:" seguito dal loro dialogo.`,
      mode: 'multi'
    },
    {
      title: "Modello di Dialogo per l'Apprendimento Linguistico",
      content: `Scrivi un dialogo conversazionale tra due parlanti per studenti di lingue.
- Lo scenario è [ordinare cibo in un vivace mercato di strada].
- Il parlante 1 è [un venditore locale amichevole che consiglia i suoi piatti migliori].
- Il parlante 2 è [un viaggiatore che prova la cucina locale per la prima volta].
- Includi [esitazioni naturali, frasi cortesi e contesto culturale].
- Il dialogo dovrebbe sembrare autentico e aiutare gli studenti con [frasi conversazionali quotidiane].

Formatta ogni riga come "Speaker 1:" o "Speaker 2:" seguito dal loro dialogo.`,
      mode: 'multi'
    }
  ]
};
